import React from "react";
import { formatEuro } from "./formatters";
import styles from "./DossierDashboard.module.scss";

const RentComparator = ({ stats, onScrollTo }) => {
  if (!stats.rentStats || stats.rents.length < 2) return null;
  const { max, median, spread } = stats.rentStats;
  const medianPct = max > 0 ? (median / max) * 100 : 0;
  return (
    <div className={styles.sect}>
      <div className={styles.sectTitle}>
        <span>Loyers HT comparés</span>
        <span className={styles.sectTitleRight}>
          écart {formatEuro(spread)} · médiane {formatEuro(median)}
        </span>
      </div>
      {stats.rents.map((r) => (
        <button
          key={r.index}
          type="button"
          className={styles.barRow}
          onClick={() => onScrollTo(r.index)}
          title={`${r.reference} — aller au devis`}
        >
          <span className={styles.barName}>{r.reference}</span>
          <span className={styles.barTrack}>
            <span
              className={styles.barFill}
              style={{ width: (r.rentHT / max) * 100 + "%", display: "block" }}
            />
            <span
              className={styles.medianTick}
              style={{ left: medianPct + "%" }}
            />
          </span>
          <span className={styles.barValue}>{formatEuro(r.rentHT)}</span>
        </button>
      ))}
      <div className={styles.note}>
        trait rouge = médiane · clic sur une barre → aller au devis
      </div>
    </div>
  );
};

export default RentComparator;
